import { render, staticRenderFns } from "./TicketView.vue?vue&type=template&id=2d865cf8&scoped=true&lang=pug&"
import script from "./TicketView.vue?vue&type=script&lang=js&"
export * from "./TicketView.vue?vue&type=script&lang=js&"
import style0 from "./TicketView.vue?vue&type=style&index=0&id=2d865cf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d865cf8",
  null
  
)

export default component.exports